const NotificationTransportEnum = Object.freeze({
    WEB: 'web',
    EMAIL: 'email'
});

export default NotificationTransportEnum;
